import { render, staticRenderFns } from "./preSales.vue?vue&type=template&id=10b1d4a4&scoped=true&"
import script from "./preSales.vue?vue&type=script&lang=ts&"
export * from "./preSales.vue?vue&type=script&lang=ts&"
import style0 from "./preSales.vue?vue&type=style&index=0&id=10b1d4a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1d4a4",
  null
  
)

export default component.exports